import { useState } from 'react';
import { ButtonCta } from '@components/button';
import { IconExpandFilled } from '@components/icons';
import { Modal } from '@components/modals';
import { XS_VIEWPORT } from '@constants/viewport';
import { useWindowSize } from '@hooks/use-window-size';
import classNames from 'classnames';

import { SquaredTabProps, SquaredTabsProps } from '../tabs.type';

const SquaredTab = ({ name, id, showBackground, activeTab, onChange }: SquaredTabProps) => {
  const isMobileViewport = useWindowSize(XS_VIEWPORT as number);

  return (
    <button
      key={name}
      type='button'
      className={classNames(
        'text-subtitle-s whitespace-nowrap py-3 px-4 rounded-sm justify-start items-center text-left',
        {
          'fill-secondary text-tertiary': id !== activeTab && showBackground,
          'fill-primary text-primary': id === activeTab && showBackground,
          'fill-secondary text-tertiary hover:text-primary': id !== activeTab && !showBackground,
          'fill-tertiary text-primary': (id === activeTab && !showBackground) || isMobileViewport,
        }
      )}
      onClick={() => onChange(id)}>
      {name}
    </button>
  );
};

export const SquaredTabs = ({ tabs, onChange, activeTab, showBackground }: SquaredTabsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobileViewPort = useWindowSize(XS_VIEWPORT);

  const handleClose = () => setIsOpen(false);

  const onMobileChange = (tab: string) => {
    setIsOpen(false);
    onChange(tab);
  };

  return (
    <>
      {isMobileViewPort ? (
        <ButtonCta
          className='whitespace-nowrap flex items-center capitalize shrink-0 text-subtitle-s'
          paddingClasses='px-3 py-2'
          onClick={() => setIsOpen(true)}>
          {activeTab}
          <IconExpandFilled className='w-4 h-4 fill-none' />
        </ButtonCta>
      ) : (
        tabs.map((tab) => (
          <SquaredTab
            key={tab.name}
            id={tab.id}
            name={tab.name}
            activeTab={activeTab}
            showBackground={showBackground}
            onChange={onChange}
          />
        ))
      )}
      <Modal isOpen={isOpen} handleClose={handleClose} variant='sm'>
        <div className='flex flex-col text-body-s bg-primary font-normal gap-y-2 px-4 py-10'>
          {tabs.map((tab) => (
            <SquaredTab
              key={tab.name}
              id={tab.id}
              name={tab.name}
              activeTab={activeTab}
              showBackground={false}
              onChange={onMobileChange}
            />
          ))}
        </div>
      </Modal>
    </>
  );
};
